import React, { useState } from 'react';
import { Box, Container, Pagination, Paper } from '@mui/material';
import {
  JobCard,
  JobFilterPanel,
  JobListControls,
  JobListEmpty,
  JobListLoading,
} from '../components';
import { useJobPostTable } from '../hooks';

export const JobPostTable = () => {
  const table = useJobPostTable();
  const [showFilters, setShowFilters] = useState<boolean>(false);

  const filterProps = {
    filters: table.filters,
    setFilters: table.setFilters,
    setSearch: table.setSearch,
    search: table.search,
  };

  return (
    <Box sx={{ minHeight: '100vh', width: '100%', bgcolor: 'grey.100' }}>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Box
          sx={{
            display: 'grid',
            gap: 2.5,
            gridTemplateColumns: { xs: '1fr', lg: '300px minmax(0,1fr)' },
          }}
        >
          <JobFilterPanel
              showFilters={showFilters}
              onToggleFilters={() => setShowFilters((prev) => !prev)}
              activeFilterCount={table.activeFilterCount}
              {...filterProps}
          />

          <Box sx={{ minWidth: 0 }}>
            <JobListControls
                jobCount={table.jobPostData.length}
                maxPages={table.maxPages}
                pageNumber={table.pageNumber}
                isLoading={table.isLoading}
                viewMode={table.viewMode}
                onViewModeChange={table.setViewMode}
                activeFilterCount={table.activeFilterCount}
            />

            <Box ref={table.scrollGridRef} sx={{ minHeight: 360 }}>
              {table.isLoading ? (
                <JobListLoading />
              ) : table.jobPostData.length > 0 ? (
                <Box
                  sx={
                    table.viewMode === 'grid'
                      ? {
                        display: 'grid',
                        gap: 2,
                        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr', xl: '1fr 1fr 1fr' },
                      }
                      : { display: 'flex', flexDirection: 'column', gap: 1.5 }
                  }
                >
                  {table.jobPostData.map((job, index) => (
                    <Box key={job.id || index} sx={{ width: '100%' }}>
                      <JobCard jobPostData={job} viewMode={table.viewMode} />
                    </Box>
                  ))}
                </Box>
              ) : (
                <JobListEmpty onClearAllFilters={table.handleClearAllFilters} />
              )}
            </Box>

            {table.jobPostData.length > 0 && table.maxPages > 1 && (
              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                <Paper sx={{ p: 1 }}>
                  <Pagination
                      page={table.pageNumber}
                      count={table.maxPages}
                      onChange={(_e, page) => table.setPageNumber(page)}
                      color="primary"
                      aria-label="Job pages"
                  />
                </Paper>
              </Box>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
